import {createContext, PropsWithChildren, useContext, useState} from 'react';

export enum EFrame {
  NONE,
  CONNECT_WALLET,
  CONFIRM,
  SUCCESS,
}

export const FrameContext = createContext({
  frame: EFrame.NONE,
  setFrame: (frame: EFrame) => {},
});

const useFrame = () => {
  const {setFrame, frame} = useContext(FrameContext);
  return {
    frame,
    closeFrame: () => {
      setFrame(EFrame.NONE);
    },
    showConnect: () => {
      setFrame(EFrame.CONNECT_WALLET);
    },
    showConfirm: () => {
      setFrame(EFrame.CONFIRM);
    },
    showSuccess: () => {
      setFrame(EFrame.SUCCESS);
    },
  };
};

interface IProps {}

export const FrameContextProvider: React.FC<PropsWithChildren<IProps>> = ({children}) => {
  const [frame, setFrame] = useState<EFrame>(EFrame.NONE);

  const context = {
    frame,
    setFrame,
  };
  return <FrameContext.Provider value={context}>{children}</FrameContext.Provider>;
};

export default useFrame;
